export default "__VITE_ASSET__hppsV_3B__"